<template>
  <group-challenge-signup-base class="choose-amount" :headline="'אתגר קבוצתי - אוכל בחוץ'"
                               :description="description"
                               :cta-button-title="'הבא >'" :cta-button-action="nextStep">
    <template v-slot:body>
      <div class="number">1</div>
      <div class="title">הגדרת יעד</div>
      <div class="description">
        הסכום שיוגדר כאן יהיה היעד השבועי שלך ושל החברים בקבוצה להוצאה על אוכל בחוץ.
      </div>
      <div class="input">
        <amount-input :value="challengeGoal" @input="onInput" label=""/>
      </div>
    </template>
  </group-challenge-signup-base>
</template>

<script>

import Segment from '@/Segment';
import BaseUI from 'base-ui';
import { mapActions, mapGetters, mapState } from 'vuex';
import GroupChallengeSignupBase
  from '@/pages/responsive-pages/authenticated/multiplayer-experience/accountability-group-challenge/GroupChallengeSignupBase';
import {
  EATING_OUT_CHALLENGE_PROTOTYPE_V1,
} from '@/pages/responsive-pages/authenticated/multiplayer-experience/accountability-group-challenge/constants';

export default {
  name: 'ChooseAmount',
  components: {
    GroupChallengeSignupBase,
    AmountInput: BaseUI.AmountInput,
  },
  data() {
    return {
      challengeGoal: 500,
    };
  },
  computed: {
    ...mapGetters('session', ['activeMemberFirstName']),
    ...mapState('accountabilityChallenge', ['ownerParticipantId']),
    description() {
      return `היי ${this.activeMemberFirstName}, איזה כיף שהחלטת לפתוח אתגר קבוצתי
      שבועי של אוכל בחוץ, איך זה עובד? קובעים יעד, מזמינים חברים ויוצאים לדרך.`;
    },
  },
  methods: {
    ...mapActions('accountabilityChallenge', ['createChallengeWithGoal']),
    onInput(value) {
      this.challengeGoal = value;
    },
    async nextStep() {
      await this.createChallengeWithGoal({ challengeGoal: this.challengeGoal, activeMemberFirstName: this.activeMemberFirstName });
      Segment.trackUserInteraction('EatingOutChallengeUserDefinedGoal',
        { challengeGoal: this.challengeGoal, challengeId: this.ownerParticipantId, shareName: EATING_OUT_CHALLENGE_PROTOTYPE_V1 });
      this.$emit('nextStep');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
@import '../../../../../scss/mixins';

  .choose-amount {
    .number {
      margin-bottom: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 32px;
      width: 32px;
      font-weight: bold;
      background-color: $riseup_light_blue;
      color: $riseup_blue;
      border-radius: 50%;
    }
    .title {
      font-weight: bold;
    }
    .input {
      margin-top: 25px;
      hegiht: 80px;
      width: 100%;
      color: $riseup-black;
      .base-input {
        color: $riseup-black;
      }
    }
  }

</style>
